import type { Integration } from '@sentry/types/types/integration';

let sentryEnabled = false;
export async function initSentry() {
  const Sentry = await import('@sentry/react');
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if(dsn) {
    const integrations: Integration[] = [
      Sentry.replayIntegration({
        maskAllText: false, // show everything on the screen
        blockAllMedia: false, // show everything on the screen
        maskAllInputs: false // show everything on the screen
      })
    ];
    sentryEnabled = true;
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      integrations: integrations,
      sendDefaultPii: true,
      tracesSampleRate: 0,
      replaysOnErrorSampleRate: 1.0,
      replaysSessionSampleRate: 0
    });
  }
}

export async function setSentryUser(email: string) {
  if(sentryEnabled) {
    const Sentry = await import('@sentry/react');
    Sentry.setUser({ email: email });
  }
}

export function reportException(e: any) {
  void reportExceptionInner(e);
}

 async function reportExceptionInner(e: any) {
  console.error(e);
  const Sentry = await import('@sentry/react');
  Sentry.captureException(e);
}
